import Axios from '../../../../Assets/Axios/Axios';

import CodeVerification from '../Components/CodeVerification';

import { EMAIL_TEMPLATES } from '../../../../Constant/Enums';

import { useToastContext } from '../../../../Context/ToastContext';

import { useFormContext } from '../FormContext';

import sendOTP from '../../../../Helpers/sendOTP';
import verifyOTP from '../../../../Helpers/validateOTP';

import { SendCode } from '../../../../Server/Query';

const MobileNumberVerification = () => {
  const { showToastMessage } = useToastContext();
  const { inputs, codeRefId } = useFormContext();

  async function handleSubmit(verificationCode) {
    const response = await verifyOTP({
      referenceID: codeRefId.mobileNumber,
      OTP: verificationCode,
    });

    if (response.data.description !== 'verification success')
      return { error: 'Entered OTP is incorrect', shouldDisplayError: true };

    const responseEmailOtp = await Axios(SendCode({ email: inputs.email, template: EMAIL_TEMPLATES.VERIFY_EMAIL }));

    if (responseEmailOtp.errors) {
      showToastMessage('Something went wrong, failed send email otp');
      return { error: true };
    }

    codeRefId.email = responseEmailOtp.data.SendCode.referenceId;

    return { error: null };
  }

  async function resendVerificationCode() {
    const response = await sendOTP({ mobileNumber: inputs.mobileNumber });
    codeRefId.mobileNumber = response.data.referenceId;
  }

  return (
    <CodeVerification
      handleSubmit={handleSubmit}
      resendVerificationCode={resendVerificationCode}
      description={
        <>
          Enter the OTP Number
          <br />
          Code is sent to
          <wbr />
          <span style={{ whiteSpace: 'nowrap' }}>{` +94** *** *${inputs.mobileNumber.slice(
            -3
          )}`}</span>
        </>
      }
    />
  );
};

export default MobileNumberVerification;
